import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Role } from "../constants";
import { checkTokenAndRole } from "./helper";

const PrivateRoute = () => {
  const removeLocalstorage = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("role");
  };
  return checkTokenAndRole() ? (
    <>
      <Outlet />
    </>
  ) : localStorage.getItem("authToken") &&
    +localStorage.getItem("role") === Role.Delivery_Boy ? (
    <>
      {removeLocalstorage()}
      <Navigate to="/auth" />
      {/* <Navigate to="/" /> */}
    </>
  ) : (
    <>
      {removeLocalstorage()}
      <Navigate to="/auth" />
    </>
  );
};

export default PrivateRoute;
